// extracted by mini-css-extract-plugin
export default {"-large":"replace-media-control-item-module__-large--rR9sQ","mediaItem":"replace-media-control-item-module__mediaItem--yCVuW"};